import { render, staticRenderFns } from "./employeeCardDialog.vue?vue&type=template&id=0eacc1f4&scoped=true"
import script from "./employeeCardDialog.vue?vue&type=script&lang=ts"
export * from "./employeeCardDialog.vue?vue&type=script&lang=ts"
import style0 from "./employeeCardDialog.vue?vue&type=style&index=0&id=0eacc1f4&prod&scoped=true&lang=css"
import style1 from "@/components/acquisitionList/ui/itemDetails.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eacc1f4",
  null
  
)

export default component.exports